// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function about_mouseIn(event, $w) {

	//Add your code for this event here:

$w('#aboutmenu').show()

}







export function button4_mouseIn(event, $w) {

	//Add your code for this event here:

	$w('#ourassetsmenu').show()

}




export function ourassetsmenu_mouseOut(event, $w) {

	//Add your code for this event here:

	$w('#ourassetsmenu').hide()

}

export function aboutmenu_mouseOut(event, $w) {

	//Add your code for this event here: 

$w('#aboutmenu').hide()

}

export function ourassetsmenu_mouseOut_1(event, $w) {

	//Add your code for this event here:

	$w('#ourassetsmenu').hide()
}